/**
 * Product recommendations: fetch section HTML, then Owl Carousel when:
 * - Mobile (≤760px): 2+ products
 * - Tablet/desktop: more than 3 products
 * Visible slides: desktop 3, tablet 2, mobile 1 (matches collection columns).
 */
(function () {
  'use strict';

  var MAX_GRID = 3;
  /** Align with Owl responsive breakpoint (0–760 uses `items: 1`). */
  var MOBILE_MAX_WIDTH = 760;

  function isMobileViewport() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
  }

  function shouldInitCarousel(itemCount) {
    if (itemCount < 2) {
      return false;
    }
    if (isMobileViewport()) {
      return true;
    }
    return itemCount > MAX_GRID;
  }

  function escapeAttr(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;');
  }

  function navTextFromIcon(root) {
    var url = root.dataset && root.dataset.navIcon;
    if (!url) {
      return ['', ''];
    }
    var u = escapeAttr(url);
    var prev =
      '<span class="product-recommendations__nav-icon">' +
      '<img src="' +
      u +
      '" alt="" width="35" height="24" decoding="async" loading="lazy" />' +
      '</span>';
    var next =
      '<span class="product-recommendations__nav-icon product-recommendations__nav-icon--next">' +
      '<img src="' +
      u +
      '" alt="" width="35" height="24" decoding="async" loading="lazy" />' +
      '</span>';
    return [prev, next];
  }

  function whenOwlReady(callback, attempt) {
    attempt = attempt || 0;
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.owlCarousel && window.jQuery.fn.owlLayout) {
      callback(window.jQuery);
      return;
    }
    if (attempt > 300) {
      return;
    }
    window.requestAnimationFrame(function () {
      whenOwlReady(callback, attempt + 1);
    });
  }

  function initOwl(root) {
    var grid = root.querySelector('ul.product-recommendations__grid');
    if (!grid) {
      return;
    }

    var items = grid.querySelectorAll(':scope > li');
    if (!shouldInitCarousel(items.length)) {
      return;
    }

    whenOwlReady(function ($) {
      var $grid = $(grid);
      if ($grid.data('owl.carousel')) {
        return;
      }

      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      grid.setAttribute('role', 'presentation');

      var rootHost = grid.closest('product-recommendations');
      var navHost = rootHost || grid;

      $grid.owlLayout().children('.inner').owlCarousel({
        loop: true,
        nav: true,
        navText: navTextFromIcon(navHost),
        dots: false,
        rtl: rtl,
        margin: 10,
        items: 3,
        slideBy: 1,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
          0: { items: 1, margin: 0 },
          761: { items: 2, margin: 16 },
          1201: { items: 3, margin: 10 }
        },
        onInitialized: function () {
          $(this.$element).owlSemantic();
        },
        onTranslated: function () {
          $(this.$element).owlSemantic();
        },
        onResized: function () {
          $(this.$element).owlSemantic();
        }
      });
    });
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._recommendationsFetched) {
        return;
      }
      var url = this.dataset.url;
      if (!url) {
        return;
      }
      this._recommendationsFetched = true;

      var self = this;
      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var wrap = document.createElement('div');
          wrap.innerHTML = text;
          var rec = wrap.querySelector('product-recommendations');
          if (rec && rec.innerHTML.trim().length) {
            self.innerHTML = rec.innerHTML;
            initOwl(self);
          }
        })
        .catch(function (e) {
          console.error(e);
          self._recommendationsFetched = false;
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
